import * as request from "request";
import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "../config";

const pem = "-----BEGIN PUBLIC KEY-----\n" +
    "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJQtuwN2Hm38niTWeqLW43II/tYUF7V2\n" +
    "8DCJ7BHVr8Bz0Zd/y15w5pBxDonX6SnxyCKPccdepJ9VmVzpkSyLRVkCAwEAAQ==\n" +
    "-----END PUBLIC KEY-----";
enum errorMessageCodes {
    E_OTHER = "E_OTHER",
    E_DATE_RANGE = "E_DATE_RANGE",
    E_FILE_WRONG_PASSWORD = "E_FILE_WRONG_PASSWORD",
    E_FILE_NO_PASSWORD = "E_FILE_NO_PASSWORD",
    E_STATEMENT_UNSUPPORTED_FORMAT = "E_STATEMENT_UNSUPPORTED_FORMAT",
    E_STATEMENT_WRONG_FORMAT = "E_STATEMENT_WRONG_FORMAT",
    E_STATEMENT_WRONG_INSTITUTION = "E_STATEMENT_WRONG_INSTITUTION",
    E_AMOUNT_BALANCE_MISMATCH = "E_AMOUNT_BALANCE_MISMATCH",
    E_API_SESSION_EXPIRED = "E_API_SESSION_EXPIRED",
    E_DUPLICATE_STATEMENT = "E_DUPLICATE_STATEMENT",
    E_FILE_IO = "E_FILE_IO",
    E_FILE_NOT_STATEMENT = " E_FILE_NOT_STATEMENT",
    E_FILE_UNSUPPORTED_FORMAT = "E_FILE_UNSUPPORTED_FORMAT",
    E_NOT_ACCEPTED = "E_NOT_ACCEPTED",
    E_STATEMENT_ERRONEOUS_DATA = "E_STATEMENT_ERRONEOUS_DATA",
    E_STATEMENT_NO_TRANSACTIONS = "E_STATEMENT_NO_TRANSACTIONS",
}
const listOfErrorMessages = [
    {
        errorCode: errorMessageCodes.E_STATEMENT_WRONG_INSTITUTION,
        errorMsg: "Uploaded file doesn't belong to the selected institution. Please check your institution or pdf.",
    },
    {
        errorCode: errorMessageCodes.E_STATEMENT_UNSUPPORTED_FORMAT,
        errorMsg: "Unsupported statement format.",
    },
    {
        errorCode: errorMessageCodes.E_STATEMENT_WRONG_FORMAT,
        errorMsg: "Wrong file format. Please upload only pdf format.",
    },
    {
        errorCode: errorMessageCodes.E_FILE_WRONG_PASSWORD,
        errorMsg: "Wrong pdf password entered. "
            + "Please provide the correct pdf password.",
    },
    {
        errorCode: errorMessageCodes.E_FILE_NO_PASSWORD,
        errorMsg: "This pdf file contains password. Please provide the password along with the pdf while uploading.",
    },
    {
        errorCode: errorMessageCodes.E_DATE_RANGE,
        errorMsg: "No bank transactions in the expected date range.",
    },
    {
        errorCode: errorMessageCodes.E_AMOUNT_BALANCE_MISMATCH,
        errorMsg: "Calculated amounts/balances do not match actual values.",
    },
    {
        errorCode: errorMessageCodes.E_API_SESSION_EXPIRED,
        errorMsg: "API session expired without the client taking any further action.",
    },
    {
        errorCode: errorMessageCodes.E_DUPLICATE_STATEMENT,
        errorMsg: "User has uploaded duplicate statements.",
    },
    {
        errorCode: errorMessageCodes.E_FILE_IO,
        errorMsg: "Can not open uploaded file.",
    },
    {
        errorCode: errorMessageCodes.E_FILE_NOT_STATEMENT,
        errorMsg: "Uploaded file is not a valid bank statement.",
    },
    {
        errorCode: errorMessageCodes.E_FILE_UNSUPPORTED_FORMAT,
        errorMsg: "Unsupported file format. Please upload only pdf.",
    },
    {
        errorCode: errorMessageCodes.E_NOT_ACCEPTED,
        errorMsg: "Transaction did not meet the criteria set by acceptance policy.",
    },
    {
        errorCode: errorMessageCodes.E_STATEMENT_ERRONEOUS_DATA,
        errorMsg: "Statement contains erroneous data.",
    },
    {
        errorCode: errorMessageCodes.E_STATEMENT_NO_TRANSACTIONS,
        errorMsg: "Statement contains no transactions.",
    },
    {
        errorCode: errorMessageCodes.E_OTHER,
        errorMsg: "Could not upload file.",
    },
]
export async function makeApiCall(path: string, apiBody: any) {
    const res = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/bs-service/${path}`,
        method: "post",
        data: apiBody,
    });
    return res.data;
}

export function getMonths(months) {
    const today = new Date();
    const month = today.getMonth();

    const monthArray = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];

    const menuMonths = [];

    for (let count = months ; count > 0; count--) {
        menuMonths.push(`${monthArray[((12 + month - count) % 12)]} `);
    }
    return menuMonths;
}

function monthDiff(d1, d2) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    const monthsDiff = months <= 0 ? 0 : months;
    return monthsDiff + 1;
}

export function getBankStatementMonths(fromMonth, toMonth) {
    const from = fromMonth.split("-").map((d) => parseInt(d, 10))
    const to = toMonth.split("-").map((d) => parseInt(d, 10))
    const fromDate = new Date(from[0], from[1] - 1, 1)
    const toDate = new Date(to[0], to[1] - 1, 1)
    return monthDiff(fromDate, toDate);
}

// export function encryptPassword(password: string) {
//     const publicKey: any = forge.pki.publicKeyFromPem(pem);
//     // convert string to UTF-8 encoded bytes
//     const buffer = forge.util.createBuffer(password, "utf8");
//     const bytes = buffer.getBytes();
//     // encrypt data with a public key using RSAES PKCS#1 v1.5
//     const encrypted = publicKey.encrypt(bytes, "RSAES-PKCS1-V1_5");
//     // base64-encode encrypted data to send to server
//     const b16Encoded = forge.util.bytesToHex(encrypted)
//     return b16Encoded;
// }
